import axios from "axios";
import serverHost from "./serverHost";

export default {
  get(route, data) {
    return request("get", route, data);
  },
  post(route, data) {
    return request("post", route, data);
  },
  // put(route, data) {
  //   return request("put", route, data);
  // },
  // delete(route, data) {
  //   return request("delete", route, data);
  // },
};

const request = (method = "post", url, data) => {
  const apiInstance = axios.create({
    baseURL: serverHost("peij"),
    timeout: 300000,
  });

  return new Promise((resolve, reject) => {
    apiInstance({
      method,
      url,
      data,
      headers: { "x-access-token": localStorage.getItem("user_id") },
    })
      .then((res) => resolve(res.data))
      .catch((err) => {
        if (err.response) {
          const { status } = err.response;

          if (status === 401) {
            localStorage.removeItem("user_id");
            return window.location.replace("/painel/signin?999");
          }

          if (status === 403) {
            return window.location.replace("/painel/app/notauthorized");
          }
        }

        reject(err);
      });
  });
};
